// extracted by mini-css-extract-plugin
export default {"container":"drag-preview_container__4pWDx","list":"drag-preview_list__xGCtE"};